module.exports = __webpack_public_path__ + "static/media/gymnastics.27e54b95.svg";